import React, { Component } from 'react'

import { connect } from 'react-redux'

import Page from '../../Components/Page'
import Card from '../../Components/Card'

import './Subscribe.css'

import * as actions from './actions'

const ms = s => ({
    ...s.challengeState
})

class Subscribe extends Component {

    constructor(props) {
        super(props)
        this.state = {
            number: '',
            success: false
        }
    }

    subscribe = () => {
        const { number } = this.state
        const { id, subscribe } = this.props

        subscribe({ id, number }).then(
            (doc, err) => {
                if (!err) {
                    this.setState({ success: true, number:'' })
                }
            })
    }

    onChange = e => this.setState({ number: e.target.value })

    render() {

        const { number, success } = this.state
        const { name, history } = this.props

        return (
            <Page>
                {
                    success ?
                        <Card>
                            <div className="center" style={{textAlign:'center'}}>
                                <h1 className="title2">Thank you for subscribing!</h1>
                            </div>
                        </Card> :
                        <Card>
                            <div className="center">
                                <h1 className="title2">Congratulations {name && name.split(" ")[0]}!</h1>
                                <p style={{ textAlign: 'center' }}>Get a text when the app is available on the App Store or Google Play Store</p>
                                <div><input placeholder="405 555 5555" onChange={this.onChange} value={number} style={{ textAlign: 'center', width: '150px' }} /></div>
                                <button className="accept_btn" style={{ margin: '20px' }} onClick={this.subscribe}>Subscribe</button>
                                {/* <div className="appstore_logos"></div> */}
                            </div>
                        </Card>
                }
            </Page>
        )
    }
}

export default connect(ms, actions)(Subscribe)




// WEBPACK FOOTER //
// ./src/Pages/Subscribe/index.js